import { SVGProps } from "react";

export const AcceptFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="5" width="24" height="24" rx="12" fill="white"/>
    <rect x="2.5" y="2.5" width="29" height="29" rx="14.5" stroke="white" stroke-opacity="0.3" stroke-width="5"/>
    <path d="M11.4004 16.6496L15.4377 20.8L22.6004 12.8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
